﻿<div class="form-component">
    <h4 *ngIf="clientId > 0">
        Edit client
    </h4>
    <h4 *ngIf="!clientId">
        Create new client
    </h4>

    <form #form="ngForm" (ngSubmit)="onSave(form)">
        <!-- Client Name -->
        <div class="input-group">
            <label for="clientName">
                Client name:<span class="required"> * </span>
            </label>
            <div>
                <input  name="clientName" #clientName="ngModel" type="text"  placeholder="Client Name" [class.invalid]="clientName.invalid" [(ngModel)]="client.clientName" required>
                <div *ngIf="clientName.invalid">
                    <span class="error">Client name is required</span>
                </div>
            </div>
        </div>

        <!-- Registration Number -->
        <div class="input-group">
            <label for="registrationNumber">
                Registration number:<span class="required"> * </span>
            </label>
            <div>
                <input name="registrationNumber" #registrationNumber="ngModel" type="text" placeholder="Registration Number" [class.invalid]="registrationNumber.invalid" [(ngModel)]="client.registrationNumber" required>
                <div *ngIf="registrationNumber.invalid">
                    <span class="error">Registration number is required</span>
                </div>
            </div>
        </div>

        <!-- Country -->
        <div class="input-group">
            <auto-complete-dropdown
                [options]="countries"
                [label]="'Country'"
                [placeholder]="'Select a country...'"
                [initialValue]="selectedCountryId"
                [required]="true"
                [invalid]="!selectedCountryId && formSubmitted"
                [validationMessage]="'Country is required'"
                [displayWith]="displayCountry"
                (selectionChange)="onCountrySelectionChange($event)">
            </auto-complete-dropdown>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button type="submit" class="button" [disabled]="form.invalid || isSaving">
                <span *ngIf="isSaving" class="loading-spinner"></span>
                <i *ngIf="!isSaving" class="fas fa-save"></i>
                Save
            </button>
            <button type="button" class="button-cancel" (click)="onClear()">
                <i class="fas fa-cancel"></i> Clear
            </button>
            <button type="button" class="button-back" (click)="onBack()">
                <i class="fas fa-arrow-left"></i> Back To Client List
            </button>
        </div>
    </form>
</div>